import moment from "moment";

export function formatSqlDate(sqlDate) {
  if (!sqlDate) return null;
  return moment.utc(sqlDate).format("MMM DD YYYY HH:mm:ss");
}

/**
 * Takes successful axios response and formats it to allow throw
 * @param error
 * @returns {{response: {data: {error: *}}}}
 */
export function formatError(error) {
  return {
    response: {
      data: { error },
    },
  };
}

/**
 * Ensures phone number parsing consistency by removing leading 1's and non-numerical characters
 * @param   {string} str  The input phone number string
 * @returns {string}
 */
export function stripPhoneNumber(str) {
  // Remove everything that isn't a number: +1 (222) 333-4444 => 12223334444
  str = str.replace(/[^\d]/g, "");

  // Prevent mis-parsing by removing leading 1
  if (/^1/.test(str)) {
    str = str.slice(1);
  }
  return str;
}

/**
 * Converts a phone number string into a human readable standard
 * @param   {string} str  The input phone number string
 * @returns {string}
 */
export function readablePhoneNumber(str) {
  if (!str) {
    return "";
  }
  str = stripPhoneNumber(str);

  return `1 (${str.substr(0, 3)}) ${str.substr(3, 3)}-${str.substr(6, 4)}`;
}

export function sortByString(sortBy, sortAsc, array) {
  return array.sort((a, b) => {
    let comparison = 0;

    if (!a.hasOwnProperty(sortBy) || !b.hasOwnProperty(sortBy)) {
      // property doesn't exist on either object
      return 0;
    }

    // Use toUpperCase() to ignore character casing
    let sortA = a[sortBy];
    let sortB = b[sortBy];

    if (typeof a[sortBy] === "string") {
      // Use toUpperCase() to ignore character casing
      sortA = sortA.toUpperCase();
      sortB = sortB.toUpperCase();
    }

    if (sortA > sortB) {
      comparison = 1;
    } else if (sortA < sortB) {
      comparison = -1;
    }
    if (!sortAsc) {
      comparison *= -1;
    }

    return comparison;
  });
}

export function isZeroLengthString(val) {
  return !val || /^\s*$/.test(val);
}

export function getChannelFlagColor(statusCode) {
  switch (statusCode) {
    case 0:
      return "grey";
    case 1:
      return "green";
    case -1:
      return "red";
    default:
      return "blue"; //new Code. Not expected indicated with blue.
  }
}
